import {
  extractData,
  getSeoKey,
  getServicePlans,
  ServicePlansResponse,
} from "api"
import SeoMetaData from "common/SeoMetaData"
import { StaticPropsFactoryProps } from "common/StaticPropsFactory"
import ServicePlansPage from "components/ServicePlans/ServicePlansPage"
// import ServicePlansPage from "components/pages/ServicePlans/ServicePlansPage"
import { GetStaticProps } from "next"

type ServicePlansProps = StaticPropsFactoryProps & {
  pageData: ServicePlansResponse
}

export const getStaticProps: GetStaticProps<
  ServicePlansProps,
  any
> = async () => {
  const dataServicePlans = await getServicePlans().then(extractData)
  const seo = await getSeoKey("servicePlans").then(extractData)

  return {
    props: {
      pageData: dataServicePlans || null,
      seo: seo,
    },
    revalidate: 60,
  }
}

const ServicePlans = ({ pageData, seo }: ServicePlansProps) => {
  return (
    <>
      <SeoMetaData data={seo} />
      <ServicePlansPage data={pageData} />
    </>
  )
}

export default ServicePlans
